import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import ProductUtils from "../../../../utils/product-utils";
import {Product} from "../../../../model/product";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ProductValueFormComponent} from "../../products-container/product-value-form/product-value-form.component";
import {Property} from "../../../../model/property";

@Component({
  selector: 'app-kampfm-information',
  templateUrl: './kampfm-information.component.html',
  styleUrls: ['./kampfm-information.component.css']
})
export class KampfmInformationComponent implements OnInit {

  kampfmProduct: Product;
  selectedProperty: Property;
  @ViewChild(ProductValueFormComponent) productValueFormComponent: ProductValueFormComponent;

  protected readonly ProductUtils = ProductUtils;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private readonly dialogRef: MatDialogRef<KampfmInformationComponent>) {
  }

  /**
   * Initializes the component:
   * - Sets the first product from the dialog data as 'kampfmProduct'
   * - Sets the selected property from the dialog data
   */
  ngOnInit(): void {
    this.kampfmProduct = this.data?.products?.[0] ?? undefined;
    this.selectedProperty = this.data?.selectedProperty ?? undefined;
  }

  /**
   * Closes the dialog, passing 'false' to indicate  cancellation
   */
  public cancelModal(): void{
    this.dialogRef.close(false);
  }

  /**
   * Validates the product value form of the product value form component (if it exists) and closes the modal.
   * The dialog will not close if the form is not valid.
   */
  public submitModal(): void{
    if(this.productValueFormComponent && !this.productValueFormComponent.isProductValueFormValid()){
      return;
    }
    this.dialogRef.close(true);
  }
}
